<template>
  <div class="package">
    <div class="odiv1">
      <el-form :inline="true" class="demo-form-inline" v-bind:class="{form:active}">
        <el-form-item label="组方标识：">
          <el-input v-model="inputname" placeholder="新建组方名不重复"></el-input>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData1"
        border
        style="width: 50%;border: 1px solid #d6d3d3"
        :header-cell-style="tableHeaderColor"
      >
        <el-table-column type="index" label="序号" width="100"></el-table-column>

        <el-table-column prop="value" label="药名"></el-table-column>

        <el-table-column prop="number" label="数量">
          <template slot-scope="{row}">
            <el-input v-model="row.number"></el-input>
          </template>
        </el-table-column>

        <el-table-column prop="unit" label="单位"></el-table-column>

        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button @click="deleteRow(scope.$index,tableData1)" type="danger" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-autocomplete
        :class="{autocomplete:active}"
        v-model="state"
        :fetch-suggestions="querySearchAsync"
        placeholder="输入药品名或选择搜索"
        @select="handleSelect"
      ></el-autocomplete>
      <el-row :class="{button:active}">
        <el-button type="primary" @click="addMedicine">保存组方</el-button>
        <el-button type="info" plain @click="backMedicine">返回</el-button>
      </el-row>
    </div>
  </div>
</template>
<style type="text/css" scoped>
  .el-button--primary {
    color: #fff;
    background-color:  rgb(60, 110, 169);
    border-color: rgb(60, 110, 169);
  }
  .el-button--primary.is-disabled, .el-button--primary.is-disabled:active, .el-button--primary.is-disabled:focus, .el-button--primary.is-disabled:hover {
    color: #fff;
    background-color: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
  }
  .el-button--primary:focus, .el-button--primary:hover {
    background: rgba(60, 110, 169, 0.65);
    border-color: rgba(60, 110, 169, 0.65);
    color: #fff;
  }
.form {
  padding-top: 10px;
  padding-left: 5px;
}

.autocomplete {
  width: 380px;
  margin-top: 40px;
}

.package .odiv1 {
  background: white;
  padding-bottom: 50px;
  padding-left: 10px;
}

.autocomplete {
  width: 840px;
}

.button {
  margin: 30px 300px;
}
</style>
<script>
export default {
  name: "package",
  data() {
    return {
      tableData1: [],
      tableData: [],
      active: true,
      state: "",
      restaurants: [],
      inputname: "",
      zufangItems: {
        zufangItems: [],
        zufangLogo: ""
      }
    };
  },
  //实例化就获取数据
  mounted: function() {
    this.$axios({
      url: "/api/medicines",
      method: "GET"
    })
      .then(res => {
        let resData = res.data.data;
        this.tableData = resData;
        this.restaurants = this.loadAll();
      })
      .catch(err => {
        console.log(err.data);
      });
  },
  methods: {
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:rgb(198, 226, 255);color: black;";
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#f2f2f2;color: #a4a7af;";
      }
    },
    deleteRow(index, rows) {
      this.$confirm("是否确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          rows.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    loadAll() {
      return this.tableData;
    },
    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 300 * Math.random());
    },
    createStateFilter(queryString) {
      return state => {
        return state.value.indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect(item) {
      let tabData = this.tableData1;
      let itemId = item.id;
      let pass = false;
      for (let i = 0; i < tabData.length; i++) {
        if (tabData[i].id == itemId) {
          pass = true;
          break;
        }
      }
      if (pass) {
        this.$confirm("此药物已存在，是否依旧保存?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            item.number = 0;
            this.tableData1.push(item);
            this.state = "";
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消"
            });
          });
      } else {
        item.number = 0;
        this.tableData1.push(item);
        this.state = "";
      }
    },
    addMedicine: function() {
      //点击保存药方的方法
      for (let i = 0; i < this.tableData1.length; i++) {
        let thisData = {
          medicineId: this.tableData1[i].id,
          number: this.tableData1[i].number,
          unit: this.tableData1[i].unit
        };
        this.zufangItems.zufangItems.push(thisData);
      }
      if (this.inputname != "" && this.zufangItems.zufangItems != "") {
        this.zufangItems.zufangLogo = this.inputname;
        this.tijiao();
      } else {
        this.$alert("请添加完整信息");
      }
    },
    tijiao() {
      this.$axios({
        url: "/api/zufangs",
        method: "POST",
        data: this.zufangItems
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$message({
              message: "保存成功！",
              type: "success"
            });
            this.$router.push({ path: "./package" });
          } else {
            this.$message({
              message: "药品不能重复",
              type: "success"
            });
          }

          if (res.data.code == 400) {
            this.$alert("组方标识已存在，请重新输入");
          }
          this.zufangItems = {
            zufangItems: [],
            zufangLogo: ""
          };
        })
        .catch(err => {
          this.$alert("增加组方失败");
        });
    },
    backMedicine: function() {
      this.$router.push({ path: "/home/project/Package" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// addNew.vue?4b437acd